(() => {
 if(window.ixCartRevisionReady)return;window.ixCartRevisionReady=true;
 const root=window.Shopify?.routes?.root||'/';
 let prepaid=false;let offerTrigger;let pending=false;
 const drawer=()=>document.getElementById('CartDrawer');
 const money=n=>'₹ '+new Intl.NumberFormat('en-IN',{minimumFractionDigits:0,maximumFractionDigits:0}).format(n/100);
 const compactMoney=n=>'₹'+new Intl.NumberFormat('en-IN',{minimumFractionDigits:0,maximumFractionDigits:1}).format(n/100);
 const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?0:340;
 const wait=ms=>new Promise(resolve=>setTimeout(resolve,ms));
 function enableSwipeToClose(d){
  const inner=d?.querySelector(':scope > .drawer__inner'),overlay=d?.querySelector(':scope > .overlay');
  if(!inner||!overlay||inner.dataset.ixSwipeClose==='true')return;
  inner.dataset.ixSwipeClose='true';
  const state={tracking:false,horizontal:false,id:null,startX:0,startY:0,lastX:0,lastTime:0,moveX:0,velocityX:0,overlayOpacity:1,suppressClickUntil:0};
  const duration=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?0:260;
  const reset=()=>{
   state.tracking=false;state.horizontal=false;state.id=null;state.moveX=0;state.velocityX=0;
   inner.classList.remove('ix-swipe-active');inner.style.transform='';inner.style.transition='';
   overlay.style.opacity='';overlay.style.transition='';
  };
  const point=(event)=>Array.from(event.changedTouches||[]).find(t=>t.identifier===state.id)||event.changedTouches?.[0];
  const blocked=target=>Boolean(target.closest('input,textarea,select,[contenteditable="true"],#IxOffers:not([hidden])'));
  inner.addEventListener('touchstart',event=>{
   if(event.touches.length!==1||!d.hasAttribute('open')||!d.hasAttribute('active')||blocked(event.target))return;
   const touch=event.changedTouches[0],now=performance.now();
   state.tracking=true;state.horizontal=false;state.id=touch.identifier;state.startX=state.lastX=touch.clientX;state.startY=touch.clientY;
   state.lastTime=now;state.moveX=0;state.velocityX=0;state.overlayOpacity=parseFloat(getComputedStyle(overlay).opacity)||1;
  },{capture:true,passive:true});
  inner.addEventListener('touchmove',event=>{
   if(!state.tracking)return;
   const touch=point(event);if(!touch)return;
   const dx=touch.clientX-state.startX,dy=touch.clientY-state.startY;
   if(!state.horizontal){
    if(Math.abs(dx)<10&&Math.abs(dy)<10)return;
    if(dx<=0||Math.abs(dx)<=Math.abs(dy)*1.15){state.tracking=false;return;}
    state.horizontal=true;inner.classList.add('ix-swipe-active');
   }
   event.preventDefault();event.stopPropagation();
   clearTimeout(d.gesture?.longPressTimer);
   const now=performance.now(),elapsed=Math.max(1,now-state.lastTime),width=inner.getBoundingClientRect().width;
   state.moveX=Math.max(0,Math.min(dx,width));state.velocityX=(touch.clientX-state.lastX)/elapsed;state.lastX=touch.clientX;state.lastTime=now;
   inner.style.transform=`translate3d(${state.moveX}px,0,0)`;
   overlay.style.opacity=String(state.overlayOpacity*Math.max(0,1-state.moveX/width));
  },{capture:true,passive:false});
  const finish=event=>{
   if(!state.tracking||!state.horizontal){state.tracking=false;return;}
   event.preventDefault();event.stopPropagation();clearTimeout(d.gesture?.longPressTimer);
   const width=inner.getBoundingClientRect().width,shouldClose=state.moveX>=width*.28||(state.moveX>=48&&state.velocityX>=.55),ms=duration();
   state.suppressClickUntil=performance.now()+450;
   inner.classList.remove('ix-swipe-active');inner.style.transition=`transform ${ms}ms cubic-bezier(.32,.72,0,1)`;
   overlay.style.transition=`opacity ${Math.min(ms,220)}ms ease-out`;
   if(shouldClose){
    inner.style.transform=`translate3d(${width}px,0,0)`;overlay.style.opacity='0';
    setTimeout(()=>{if(d.hasAttribute('open'))d.hide();reset();},ms);
   }else{
    inner.style.transform='translate3d(0,0,0)';overlay.style.opacity=String(state.overlayOpacity);
    setTimeout(reset,ms);
   }
  };
  inner.addEventListener('touchend',finish,{capture:true,passive:false});
  inner.addEventListener('touchcancel',finish,{capture:true,passive:false});
  inner.addEventListener('click',event=>{if(performance.now()<state.suppressClickUntil){event.preventDefault();event.stopPropagation();}},true);
  new MutationObserver(records=>{if(records.some(r=>r.attributeName==='open'&&!d.hasAttribute('open')))reset();}).observe(d,{attributes:true,attributeFilter:['open']});
 }
 function couponBusy(button,busy){
  if(!button)return;
  button.disabled=busy;
  button.classList.toggle('is-loading',busy);
  if(busy)button.setAttribute('aria-busy','true');else button.removeAttribute('aria-busy');
 }
 function status(text){drawer()?.querySelectorAll('.ix-coupon-status').forEach(e=>{if(e.textContent!==text)e.textContent=text;e.classList.toggle("ix-status-success",Boolean(text&&!text.startsWith("Could")&&!text.startsWith("Enter")&&!text.startsWith("This")&&!text.startsWith("Unable")));});}
 function refreshOffer(){
  const d=drawer(),f=d?.querySelector('[data-ix-total]');if(!f)return;
  const total=Number(f.dataset.ixTotal);const saving=Math.round(total*.1);
  const heading=d.querySelector('.ix-offer-main strong'),button=d.querySelector('.ix-offer-main [data-ix-apply]'),price=d.querySelector('.ix-price-total'),originalPrice=d.querySelector('.ix-price-original');
  const savingsRow=d.querySelector('.ix-prepaid-row'),payableRow=d.querySelector('.ix-prepaid-payable');
  if(savingsRow){savingsRow.hidden=!prepaid;let t='−'+money(saving);if(savingsRow.querySelector('b').textContent!==t)savingsRow.querySelector('b').textContent=t;}
  if(payableRow){payableRow.hidden=!prepaid;let t=money(total-saving);if(payableRow.querySelector('b').textContent!==t)payableRow.querySelector('b').textContent=t;}
  f.classList.toggle('is-prepaid',prepaid);
  if(heading){const t=prepaid?compactMoney(saving)+' savings with this coupon':'10% off on Prepaid Orders';if(heading.textContent!==t)heading.textContent=t;}
  if(button){const t=prepaid?'Remove':'Apply';if(button.textContent!==t)button.textContent=t;button.dataset.ixRemove=String(prepaid);}
  if(price){const t=prepaid?compactMoney(total-saving):money(total);if(price.textContent!==t)price.textContent=t;}
  if(originalPrice){originalPrice.hidden=!prepaid;const t=compactMoney(total);if(originalPrice.textContent!==t)originalPrice.textContent=t;}
  status('');
 }
 function showOffers(button){const p=document.getElementById('IxOffers');if(!p)return;offerTrigger=button;p.hidden=false;button?.setAttribute('aria-expanded','true');p.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}],{duration:motion(),easing:'cubic-bezier(.16,1,.3,1)'});p.querySelector('[data-ix-offers-close]').focus();}
 function closeOffers(){const p=document.getElementById('IxOffers');if(!p||p.hidden)return;p.hidden=true;offerTrigger?.setAttribute('aria-expanded','false');offerTrigger?.focus();}
 async function apply(code,remove=false,button=null){
  if(pending)return;code=code.trim().toUpperCase();
  if(code==='PAYDEAL'){
    pending=true;couponBusy(button,true);
    try{
      await wait(motion()?320:0);
      prepaid=!remove;
      refreshOffer();
      status('');
      closeOffers();
    }finally{
      pending=false;couponBusy(button,false);
    }
    return;
  }
  if(!code){status('Enter a coupon code.');return;}
  pending=true;couponBusy(button,true);status('Checking coupon…');
  try{
   const before=await(await fetch(root+'cart.js')).json();
   const existing=(before.discount_codes||[]).filter(x=>x.applicable).map(x=>x.code);
   const codes=[...new Set([...existing,code])];
   const res=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(',')})});
   const cart=await res.json();if(!res.ok)throw Error(cart.description||'Unable to apply this code.');
   if(!(cart.discount_codes||[]).some(x=>x.code.toUpperCase()===code&&x.applicable)){
    await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:existing.join(',')})});
    throw Error('This code is not available for this cart.');
   }
   prepaid=false;
   document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
   document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
   status('✓ Coupon ' + code + ' applied!');
   closeOffers();
  }catch(e){status(e.message||'Could not apply coupon.');}finally{pending=false;couponBusy(button,false);}
 }
 document.addEventListener('click',e=>{
  const all=e.target.closest('.ix-all-coupons');if(all){showOffers(all);return;}
  if(e.target.closest('[data-ix-offers-close]')){closeOffers();return;}
  const applyButton=e.target.closest('[data-ix-apply]');if(applyButton){apply(applyButton.dataset.ixApply,applyButton.dataset.ixRemove==='true',applyButton);}
 });
 document.addEventListener('submit',e=>{if(e.target.id==='IxCouponForm'){e.preventDefault();apply(document.getElementById('IxCouponCode').value,false,e.target.querySelector('[type="submit"]'));}});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!document.getElementById('IxOffers')?.hidden){e.preventDefault();e.stopImmediatePropagation();closeOffers();}},true);
 const d=drawer();
 if(d){
  enableSwipeToClose(d);
  new MutationObserver(()=>refreshOffer()).observe(d,{childList:true,subtree:true});
  new MutationObserver(records=>{
    for(const r of records){
      if(r.attributeName==='open'&&!d.hasAttribute('open')){
        const p=document.getElementById('IxOffers');if(p)p.hidden=true;
      }
    }
  }).observe(d,{attributes:true,attributeFilter:['open']});
 }
 refreshOffer();
})();
